import _sortBy from 'lodash-es/sortBy';
import _groupBy from 'lodash-es/groupBy';
import _flatMap from 'lodash-es/flatMap';
import _orderBy from 'lodash-es/orderBy';
import _sortedUniq from 'lodash-es/sortedUniq';
import { Classroom } from '@teetsh/app/src/types/classroom';
import getMonth from '@teetsh/app/src/utils/time/getMonth';
import getYear from '@teetsh/app/src/utils/time/getYear';
import { Color } from '@teetsh/app/src/types/colors';
import { Tag } from '@teetsh/app/src/types/event';

export function getMutualTags(classrooms: Classroom[]): Tag[] {
  const allTags = _flatMap(classrooms, classroom => classroom.tags);
  const groupedById = _groupBy(allTags, t => t.id);

  const commonTagIds = Object.keys(groupedById).filter(
    tagId => groupedById[tagId].length === classrooms.length,
  );
  return _orderBy(
    commonTagIds
      .map(cTagId => allTags.find(t => t.id === cTagId))
      .filter(t => t) as Tag[],
    'position',
    ['asc'],
  );
}

export function getMutualWorkingDays(classrooms: Classroom[]): number[] {
  return _sortedUniq(
    _sortBy(_flatMap(classrooms, classroom => classroom.workingDays)),
  );
}

export const defaultTag: Tag = {
  id: '0',
  position: 1,
  color: 'gray-400' as Color,
  title: '',
};

export function getSchoolyearYear(date: Date) {
  const month = getMonth(date);
  return month >= 6 ? getYear(date) + 1 : getYear(date);
}
